import { CustomPageable } from '@/models/custom-pageable.model';
import { CustomResponse } from '@/models/custom-response.model';

export function handleResponseWithPagination(response: CustomResponse<any>): CustomResponse<CustomPageable> {

    const pageable: CustomPageable = {
        content: response.data.data,
        meta: {
            from: parseInt(response.data.from, 10),
            to: parseInt(response.data.to, 10),
            totalElements: parseInt(response.data.total, 10),
            totalPages: parseInt(response.data.last_page, 10),
        },
        params: {
            page: parseInt(response.data.current_page, 10),
            size: parseInt(response.data.per_page, 10),
        },
    };

    return {
        code: response.code,
        detail: response.detail,
        localized: response.localized,
        data: pageable,
    };
}
